import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full" }
const _hoisted_2 = {
  key: 0,
  disabled: "",
  value: ""
}
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M6 9l6 6 6-6" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createBlock("label", {
          key: 0,
          for: _ctx.name,
          class: "leading-7 text-sm text-gray-600"
        }, _toDisplayString(_ctx.label), 9, ["for"]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: [
        'relative transition-all',
        !_ctx.disabled && 'duration-300 hover:text-primary-500'
      ]
    }, [
      _createVNode("select", {
        class: [
          'w-full rounded-md appearance-none py-2 pl-3 pr-10 focus:outline-none',
          _ctx.disabled
            ? 'border border-gray-500 bg-gray-300 opacity-50 cursor-not-allowed'
            : 'bg-primary-100 hover:border-primary-600 cursor-pointer'
        ],
        name: _ctx.name,
        value: _ctx.value,
        disabled: _ctx.disabled,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', $event.target.value)))
      }, [
        (_ctx.placeholder)
          ? (_openBlock(), _createBlock("option", _hoisted_2, _toDisplayString(_ctx.placeholder), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createBlock("option", {
            key: _ctx.keyOf(option),
            value: _ctx.valueOf(option),
            selected: _ctx.value == _ctx.valueOf(option)
          }, _toDisplayString(_ctx.textOf(option)), 9, ["value", "selected"]))
        }), 128))
      ], 42, ["name", "value", "disabled"]),
      _createVNode("span", {
        class: [
          'absolute right-2 top-0 h-full w-6 text-center pointer-events-none flex items-center justify-center',
          !_ctx.disabled ? 'text-primary-500' : 'text-gray-500'
        ]
      }, [
        _hoisted_3
      ], 2)
    ], 2)
  ]))
}